// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".country-list[data-v-5e2ca6e2]{position:relative}.country-list__search[data-v-5e2ca6e2]{width:calc(100% + 24px);margin:0 -12px 10px;background-color:transparent;color:#d5d5d5;padding-top:5px!important;padding-inline-start:10px!important}", ""]);
// Exports
module.exports = exports;
